// extracted by mini-css-extract-plugin
module.exports = {"link":"_84ff5fbbc9--link--20goe","accent":"_84ff5fbbc9--accent--_p0QU","primary":"_84ff5fbbc9--primary--1z7DK","light":"_84ff5fbbc9--light--1N7qy"};